module.exports = __webpack_public_path__ + "img/02.a3c9a1f9.png";